<template>
  <div class="mb-3">
    <label class="form-label"
      >{{ data.label
      }}<span
        class="asterisk"
        :class="mode == 'write' ? 'red' : ''"
        v-if="data.mandatory"
        >*</span
      ></label
    >
    <input
      type="text"
      class="form-control"
      autocomplete="off"
      :id="data.id"
      :class="isValid ? '' : 'error'"
      v-show="mode == 'write'"
      data-toggle="datepicker"
      v-model="inputVal"
      @change.stop="checkValid()"
      readonly
    />
    <div class="form-text error_msg" v-if="!isValid && mode == 'write'">
      必須輸入{{ data.label }}！
    </div>
    <div class="input_answer" v-if="mode == 'read'">
      {{
        data.value != undefined && data.value.trim() != ""
          ? data.value
          : "未輸入"
      }}
    </div>
  </div>
</template>


<script>
import {
  ref,
  onBeforeUnmount,
  onMounted,
  nextTick,
  inject,
  watch,
  computed,
} from "vue";
import { useStore } from "vuex";
import useEventBus from "@/config/eventBus";
import "@chenfengyuan/datepicker";
import moment from "moment";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isValid = ref(true);
    const store = useStore();
    const eventBus = useEventBus();
    const inputVal = ref("");
    const daysMin = inject("daysMin");
    const months = inject("months");
    const monthsShort = inject("monthsShort");
    const startDate = ref("");
    const endDate = ref("");
    const cartItem = computed(() => store.getters["cart/items"]);

    const checkValid = () => {
      console.log(inputVal.value, props.data.id);
      if (props.mode == "write" && props.data.mandatory) {
        inputVal.value == "" ? (isValid.value = false) : (isValid.value = true);
      }
      if (props.mode == "write") {
        eventBus.emit("inputValue", {
          id: props.data.id,
          val: inputVal.value,
        });
      }
    };

    const handleNextTick = async () => {
      await nextTick();
      if (props.data.questionKey == "bkger_departure_date") {
        startDate.value = new Date();
        endDate.value =
          cartItem.value.useDateList.length > 0
            ? cartItem.value.useDateList[0]
            : "";
        console.log(endDate.value);
      } else {
        startDate.value = "";
        endDate.value = "";
      }

      setTimeout(() => {
        $("#" + props.data.id)
          .datepicker({
            autoHide: true,
            format: "yyyy-mm-dd",
            daysMin: daysMin,
            months: months,
            monthsShort: monthsShort,
            startDate: startDate.value,
            endDate: endDate.value,
          })
          .on("pick.datepicker", function (e) {
            console.log(e.currentTarget.id);
            if (e.currentTarget.id == props.data.id)
              inputVal.value = moment(e.date).format("YYYY-MM-DD");
          });
      }, 100);
      if (props.data.value != undefined) {
        inputVal.value = props.data.value;
      }
    };

    watch(
      () => inputVal.value,
      (newVal) => {
        console.log(newVal, props.data.id);
        document
          .getElementById(props.data.id)
          .dispatchEvent(new Event("change"));
      }
    );

    onMounted(() => {
      eventBus.on("checkValid", () => {
        document
          .getElementById(props.data.id)
          .dispatchEvent(new Event("change"));
      });

      eventBus.on("updatedUseDateList", () => {
        console.log("hello");
        handleNextTick();
      });

      handleNextTick();
    });

    onBeforeUnmount(() => {
      eventBus.off("checkValid");
      eventBus.off("updatedUseDateList");
    });

    return {
      inputVal,
      isValid,
      checkValid,
    };
  },
};
</script>